module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/logo-oikos.976132a1.png";